import React, { useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import PayoutListComponent from "../../components/Payout/PayoutList";



export default function PayoutList() {
    useEffect(() => {
        window.scrollTo(0, 0);
    })

    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
                document.body.classList.remove("offcanvas-active");
            }}
        >
            <div>
                <div className="container-fluid">
                    <PageHeader
                        HeaderText="Payouts"
                        Breadcrumb={[
                            { name: "Payouts", navigate: "" },
                        ]}
                    />
                    <div className="row clearfix">
                        <PayoutListComponent />
                    </div>
                </div>
            </div>
        </div>
    );
}
